import { Component, OnInit, HostListener } from "@angular/core";
import { LanguageService, Language } from "src/app/services/language/language.service";
import { Observable } from "rxjs";

@Component({
  selector: "app-language-selector",
  templateUrl: "./language-selector.component.html",
  styleUrls: ["./language-selector.component.scss"],
})
export class LanguageSelectorComponent implements OnInit {
  currentLanguage$: Observable<Language>;
  isDropdownOpen = false;
  showFeedback = false;
  feedbackMessage = "";

  constructor(private languageService: LanguageService) {
    this.currentLanguage$ = this.languageService.currentLanguage$;
  }

  ngOnInit(): void {
    // Initialize with current language
    this.checkCurrentLanguage();
  }

  private checkCurrentLanguage(): void {
    this.languageService.getPreferredLanguage().subscribe();
  }

  toggleDropdown(event: Event): void {
    event.stopPropagation();
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  closeDropdown(): void {
    this.isDropdownOpen = false;
  }

  setLanguage(lang: Language): void {
    const currentLang = this.languageService.getCurrentLanguage();

    if (currentLang !== lang) {
      this.showLanguageFeedback(lang);
      this.languageService.setLanguage(lang);

      // Get current route
      const currentUrl = window.location.pathname;
      const currentPath = currentUrl.split("/")[1] || "";

      // Special case for home page to avoid redirect component
      if (currentPath === "" || currentPath === "en" || currentPath === "de") {
        // Direct navigation to home in the selected language
        const homePath = lang === "en" ? "" : "de";
        window.location.href = "/" + homePath;
        return;
      } else {
        // Normal translation for other routes
        this.languageService.navigateToTranslatedRoute(lang);
      }
    }

    this.closeDropdown();
  }

  private showLanguageFeedback(lang: Language): void {
    this.feedbackMessage = lang === "en" ? "Switching to English..." : "Wechseln zu Deutsch...";
    this.showFeedback = true;

    // Shorter timeout for a smoother experience
    setTimeout(() => {
      this.showFeedback = false;
    }, 1000);
  }

  getCurrentLanguage(): Language {
    return this.languageService.getCurrentLanguage();
  }

  @HostListener("document:click")
  onDocumentClick(): void {
    if (this.isDropdownOpen) {
      this.closeDropdown();
    }
  }
}
